// @ts-nocheck
(function () {
  function getHeaderHeight() {
    var el =
      document.querySelector('#header-group') ||
      document.querySelector('#header-component') ||
      document.querySelector('#header') ||
      document.querySelector('#site-header');

    if (el) return el.getBoundingClientRect().height;

    var style = getComputedStyle(document.documentElement);
    return (
      parseFloat(style.getPropertyValue('--header-group-height')) ||
      parseFloat(style.getPropertyValue('--header-height')) ||
      60
    );
  }

  function scrollNav(navUl, idx) {
    if (!navUl || idx < 0) return;

    var items = navUl.querySelectorAll('li.dot');
    var active = items[idx];
    if (!active) return;

    var maxScroll = navUl.scrollHeight - navUl.clientHeight;
    if (maxScroll <= 0) {
      navUl.scrollTop = 0;
      return;
    }

    var targetScroll = active.offsetTop - navUl.clientHeight / 2 + active.offsetHeight / 2;
    navUl.scrollTo({
      top: Math.max(0, Math.min(targetScroll, maxScroll)),
      behavior: 'smooth'
    });
  }

  function destroySection(sectionEl) {
    if (!sectionEl) return;

    if (sectionEl._stickySliderScrollHandler) {
      window.removeEventListener('scroll', sectionEl._stickySliderScrollHandler);
      window.removeEventListener('resize', sectionEl._stickySliderScrollHandler);
      sectionEl._stickySliderScrollHandler = null;
    }

    if (sectionEl._stickySliderClickHandler) {
      sectionEl.removeEventListener('click', sectionEl._stickySliderClickHandler);
      sectionEl._stickySliderClickHandler = null;
    }

    var nav = sectionEl.querySelector(':scope > .sticky-slider-navigation');
    if (nav) nav.remove();
  }

  function initStickySliderSection(sectionEl) {
    if (!sectionEl) return;

    destroySection(sectionEl);

    var slides = sectionEl.querySelectorAll(':scope > .sticky-slider-slide');
    if (!slides.length) return;

    var nav = document.createElement('div');
    nav.className = 'sticky-slider-navigation';

    var navUl = document.createElement('ul');
    slides.forEach(function (slide) {
      var yearEl = slide.querySelector('.sticky-slider-year');
      var year = yearEl ? yearEl.textContent.trim() : '';
      var li = document.createElement('li');
      li.className = 'dot';
      li.innerHTML = '<a href="#' + slide.id + '">' + year + '</a>';
      navUl.appendChild(li);
    });
    nav.appendChild(navUl);
    sectionEl.prepend(nav);

    var navDots = navUl.querySelectorAll('li.dot');
    var lastIdx = navDots.length - 1;
    var activeIdx = -1;

    // Determine which slide's title is currently pinned under the header.
    function computeActiveIdx() {
      var line = getHeaderHeight() + 12;
      var idx = 0;
      slides.forEach(function (slide, i) {
        if (slide.getBoundingClientRect().top - line <= 1) idx = i;
      });
      return idx;
    }

    function setActive(idx) {
      if (idx === activeIdx) return;
      activeIdx = idx;

      navDots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === idx);
      });
      slides.forEach(function (slide, i) {
        slide.classList.toggle('active', i === idx);
      });

      nav.classList.toggle('first', idx <= 0);
      scrollNav(navUl, idx);
    }

    function updateNavigationPosition() {
      var headerH = getHeaderHeight();
      var sectionRect = sectionEl.getBoundingClientRect();
      var paddingBottom = parseFloat(getComputedStyle(sectionEl).paddingBottom) || 0;
      var lastSlide = slides[slides.length - 1];
      var boundsBottom =
        (lastSlide ? lastSlide.getBoundingClientRect().bottom : sectionRect.bottom) + paddingBottom;

      // Hide the nav before the section is reached and once it has scrolled past.
      if (sectionRect.top >= window.innerHeight || boundsBottom <= headerH + 10) {
        nav.classList.add('is-out-of-view');
        navUl.style.top = '';
        navUl.style.transform = '';
        return;
      }

      nav.classList.remove('is-out-of-view');

      var navUlHeight = navUl.clientHeight;
      var centeredTop = Math.max(0, (window.innerHeight - headerH - 40 - navUlHeight) / 2);
      var navViewportTop = headerH + centeredTop;
      var navViewportBottom = navViewportTop + navUlHeight;

      // Never let the nav extend past the end of the section content. When the
      // section is ending, this pulls the nav upward so it scrolls away with the
      // section instead of overlapping the next one.
      var clampY = 0;
      if (navViewportBottom > boundsBottom - 8) {
        clampY = boundsBottom - 8 - navViewportBottom;
      }

      navUl.style.top = centeredTop + 'px';
      navUl.style.transform = clampY ? 'translateY(' + clampY + 'px)' : '';
    }

    function onScroll() {
      setActive(computeActiveIdx());
      updateNavigationPosition();
    }

    setActive(computeActiveIdx());
    updateNavigationPosition();

    sectionEl._stickySliderScrollHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    sectionEl._stickySliderClickHandler = function (e) {
      var link = e.target.closest('.sticky-slider-navigation .dot a');
      if (!link || !sectionEl.contains(link)) return;

      e.preventDefault();

      var idx = Array.prototype.indexOf.call(navDots, link.parentElement);
      var slide = slides[idx];
      if (!slide) return;

      var slideTop = slide.getBoundingClientRect().top + window.scrollY;
      var scrollTop = window.scrollY;
      var buffer = scrollTop < slideTop ? getHeaderHeight() : 0;

      if (scrollTop > slideTop) {
        var title = slide.querySelector('.sticky-slider-title');
        buffer += title ? title.offsetHeight : 0;
      } else {
        buffer -= 2;
      }

      window.scrollTo({
        top: slideTop - Math.round(buffer),
        behavior: 'smooth'
      });
    };
    sectionEl.addEventListener('click', sectionEl._stickySliderClickHandler);
  }

  function boot(root) {
    (root || document).querySelectorAll('.sticky-slider-section').forEach(initStickySliderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector('.sticky-slider-section');
    destroySection(section);
  });
})();
